import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Hidden from '@material-ui/core/Hidden';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import ADGMImage from '../ADGMImage';
import styles from './styles';

function ADGMSuccessScreen(props) {
  const { classes, title, subTitle, mobileHeaderText, applicationId, values, buttonText, onButtonClick } = props;

  return (
    <Container className={classes.container}>
      {/* Mobile Header */}
      <Hidden smUp>
        <div className={classes.mobileTitlehead}>
          <div>{mobileHeaderText}</div>
        </div>
      </Hidden>

      <Grid container spacing={3} justify='center'>
        <Grid item xs={12} md={6}>
          <div className={classes.contentArea}>
            {/* Banner Area */}
            <div className={classes.bannerArea}>
              <Hidden smUp>
                <div className={classes.textHolder}>
                  <Typography variant='h6' component='h1' className={classes.Title}>
                    {title}
                  </Typography>
                </div>
              </Hidden>
              <div>
                <ADGMImage name='successIcon.svg' alt='success' />
              </div>
              <div className={classes.textHolderApproval}>
                <Hidden smDown>
                  <Typography variant='h6' component='h1' className={classes.Title}>
                    {title}
                  </Typography>
                </Hidden>
                <Typography variant='body1'>{subTitle}</Typography>
              </div>
            </div>

            {/* Application Id Area */}
            <Typography align='right' className={classes.applicationIdStyle}>
              {applicationId && (
                <>
                  <FormattedMessage {...messages.Application_ID} /> : <strong>{applicationId}</strong>
                </>
              )}
            </Typography>

            {/* List Area */}
            <div className={classes.detailItemHolder}>
              {(values || []).map(val => (
                <div className={classes.detailItem}>
                  <div className={classes.text}>
                    <Typography variant='body1'>{val.label}</Typography>
                    <Typography variant='h6' component='h2'>
                      {val.value}
                    </Typography>
                  </div>
                </div>
              ))}
            </div>

            {/* Button Area */}
            <div className={classes.fixedonMobileHolder}>
              <Button variant='contained' className={classes.gotoproBtn} onClick={onButtonClick}>
                {buttonText}
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
}

ADGMSuccessScreen.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  mobileHeaderText: PropTypes.string.isRequired,
  applicationId: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired,
  buttonText: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func.isRequired,
};

ADGMSuccessScreen.defaultProps = {
  subTitle: '',
};

export default withStyles(styles)(ADGMSuccessScreen);
